import db, { storage } from './firebase';

export const uploadEventImageInBase64 = (eventId, file, progress) => {
    return new Promise((resolve, reject) => {
        // create file reference
        const filePath = `events/${eventId}/${"image-" + Date.now()}`;
        const fileRef = storage.ref().child(filePath);

        // upload task        
        const uploadTask = fileRef.putString(file, 'base64', {contentType:'image/jpeg'});
        uploadTask.on('state_changed', (snapshot) => progress(snapshot), (error) => reject(error), () => {
            resolve(uploadTask.snapshot.ref);
        });
    });
}

export const getDownloadUrlFromFullPath = (filePath) => {
    return storage.ref().child(filePath).getDownloadURL();
}

export const getEventDetailsBasedOnUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    let event = null;
    let retailer = null;
    const eventSnapshot = await db.collection('Events').where("uniqueId", "==", uniqueId).get()
    eventSnapshot.docs.map(doc => {
        event = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("userId", "==", event.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        event: event,
        retailer: retailer
    }
}

export const loadInitial = (storeName) => {
    let firstName = "";
    let secondName = "";
    let nameArray = storeName.split(" ");
    if(nameArray.length > 1) {
        firstName = nameArray[0].charAt(0)
        secondName = nameArray[1].charAt(0)
    } else {
        firstName = nameArray[0].charAt(0) + nameArray[0].charAt(1)
    }
    return (firstName + secondName).toUpperCase();
}